import { useCallback, useState } from "react";

export const useToggle = (initialState = false) => {
  const [state, setState] = useState(initialState);
  const toggle = () => setState((state) => !state);
  const toggleState = useCallback(toggle, []);
  return [state, toggleState, setState];
};
